(function() {
    'use strict';

    angular
        .module('publicGatewayApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider
        .state('profile-criterion', {
            parent: 'entity',
            url: '/profile-criterion',
            data: {
                authorities: ['ROLE_USER'],
                pageTitle: 'publicGatewayApp.profileCriterion.home.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/entities/profile-criterion/profile-criteria.html',
                    controller: 'ProfileCriterionController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('profileCriterion');
                    $translatePartialLoader.addPart('profileCriterionType');
                    $translatePartialLoader.addPart('global');
                    return $translate.refresh();
                }]
            }
        })
        .state('profile-criterion-detail', {
            parent: 'entity',
            url: '/profile-criterion/{id}',
            data: {
                authorities: ['ROLE_USER'],
                pageTitle: 'publicGatewayApp.profileCriterion.detail.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/entities/profile-criterion/profile-criterion-detail.html',
                    controller: 'ProfileCriterionDetailController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('profileCriterion');
                    $translatePartialLoader.addPart('profileCriterionType');
                    return $translate.refresh();
                }],
                entity: ['$stateParams', 'ProfileCriterion', function($stateParams, ProfileCriterion) {
                    return ProfileCriterion.get({id : $stateParams.id}).$promise;
                }],
                previousState: ["$state", function ($state) {
                    var currentStateData = {
                        name: $state.current.name || 'profile-criterion',
                        params: $state.params,
                        url: $state.href($state.current.name, $state.params)
                    };
                    return currentStateData;
                }]
            }
        })
        .state('profile-criterion-detail.edit', {
            parent: 'profile-criterion-detail',
            url: '/detail/edit',
            data: {
                authorities: ['ROLE_USER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/profile-criterion/profile-criterion-dialog.html',
                    controller: 'ProfileCriterionDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: ['ProfileCriterion', function(ProfileCriterion) {
                            return ProfileCriterion.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('^', {}, { reload: false });
                }, function() {
                    $state.go('^');
                });
            }]
        })
        .state('profile-criterion.new', {
            parent: 'profile-criterion',
            url: '/new',
            data: {
                authorities: ['ROLE_USER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/profile-criterion/profile-criterion-dialog.html',
                    controller: 'ProfileCriterionDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: function () {
                            return {
                                name: null,
                                shortName: null,
                                sortOrder: null,
                                enable: null,
                                type: null,
                                measurementUnitName: null,
                                id: null
                            };
                        }
                    }
                }).result.then(function() {
                    $state.go('profile-criterion', null, { reload: 'profile-criterion' });
                }, function() {
                    $state.go('profile-criterion');
                });
            }]
        })
        .state('profile-criterion.edit', {
            parent: 'profile-criterion',
            url: '/{id}/edit',
            data: {
                authorities: ['ROLE_USER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/profile-criterion/profile-criterion-dialog.html',
                    controller: 'ProfileCriterionDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: ['ProfileCriterion', function(ProfileCriterion) {
                            return ProfileCriterion.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('profile-criterion', null, { reload: 'profile-criterion' });
                }, function() {
                    $state.go('^');
                });
            }]
        })
        .state('profile-criterion.delete', {
            parent: 'profile-criterion',
            url: '/{id}/delete',
            data: {
                authorities: ['ROLE_USER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/profile-criterion/profile-criterion-delete-dialog.html',
                    controller: 'ProfileCriterionDeleteController',
                    controllerAs: 'vm',
                    size: 'md',
                    resolve: {
                        entity: ['ProfileCriterion', function(ProfileCriterion) {
                            return ProfileCriterion.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('profile-criterion', null, { reload: 'profile-criterion' });
                }, function() {
                    $state.go('^');
                });
            }]
        });
    }

})();
